import { ResponseError } from '../../errors';
import {
  TWebChatsSyncRequest,
  TWebChatsSyncResponse,
  fetchWebChatsSync,
} from '../../repositories/chats/v2/web/chats/sync';
import { EStatusSyncChatSchema } from '../../types/chatList';
import { TContext } from '../../types/context';
import { ETelemetryEvents } from '../../types/telemetry';
import { mapChatV2VersionToV1 } from '../../utils/v2ToV1/mapChat';

export type TSyncChatsV2ParamsRequest = Omit<TWebChatsSyncRequest, 'status'> & {
  /** Раздел чатов **/
  status?: EStatusSyncChatSchema;
};

type TSyncChatsV2Params = {
  parameters: TSyncChatsV2ParamsRequest;
  cookies?: string;
};

const DOMAIN = 'critical.syncChats';

export async function syncChatsV2(
  { logger, httpApi, telemetry }: TContext,
  { cookies, parameters }: TSyncChatsV2Params,
) {
  const { status } = parameters;

  const options: TWebChatsSyncRequest = {
    ...parameters,
    status: status || EStatusSyncChatSchema.Active,
  };

  const startTime = Date.now();

  telemetry.increment(ETelemetryEvents.ChatsSynchronizeInit);

  try {
    const { response, statusCode }: TWebChatsSyncResponse = await fetchWebChatsSync({
      httpApi,
      parameters: options,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: DOMAIN,
        message: response.message || '',
        details: {
          errors: JSON.stringify(response.errors),
        },
      });
    }

    telemetry.increment(ETelemetryEvents.ChatsSynchronizeSuccess);
    telemetry.timing(ETelemetryEvents.ChatsSynchronizeTime, Date.now() - startTime);

    return {
      chats: response.chats.map(mapChatV2VersionToV1),
      movedChatIds: response.movedChatIds || [],
    };
  } catch (error) {
    telemetry.increment(ETelemetryEvents.ChatsSynchronizeFail);

    logger.error(
      {
        ...error,
        domain: DOMAIN,
        details: {
          ...error.details,
          microserviceName: 'chats',
          pathApi: '/v2/web/chats/sync/',
          parameters: JSON.stringify(options),
          cookies,
        },
      },
      { degradation: 'Синхронизация списка чатов' },
    );

    return {
      chats: null,
      movedChatIds: null,
    };
  }
}
